import React, { useEffect, useState, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import { Pane, Spinner, Text } from "evergreen-ui";
import useControlHub from "../hooks/useControlHub";
import useDebounce from "../hooks/useDebounce";
import controlhubContext from "../contexts/controlhub";
import { FREE_PLAN_NAME } from "../config";

function BillingScreen() {
  const { currentCompanyPlan } = useContext(controlhubContext);
  const history = useHistory();
  const { api } = useControlHub();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);
  const debouncedIsLoading = useDebounce(isLoading, 1800);

  useEffect(() => {
    const customerPortal = async () => {
      try {
        const response = await api.customerPortal();
        if (response?.success) {
          window.open(response?.url, "_blank");
          setError(false);
        }
      } catch (error) {
        setError(true);
      }
      setIsLoading(false);
    };
    customerPortal();
  }, [api, currentCompanyPlan, history]);

  useEffect(() => {
    if (debouncedIsLoading || error) return;
    if (currentCompanyPlan !== FREE_PLAN_NAME) {
      history.goBack();
    }
  }, [currentCompanyPlan, debouncedIsLoading, error, history]);

  return (
    <Pane
      height={240}
      alignItems="center"
      justifyContent="center"
      display="flex"
    >
      {debouncedIsLoading && <Spinner />}
      {!debouncedIsLoading && error && (
        <Text color="muted">Please contact support@controlhub.com</Text>
      )}
      {!debouncedIsLoading && !error && (
        <>
          <Link to="/">
            <Text color="muted">Activate your subscription</Text>
          </Link>
        </>
      )}
    </Pane>
  );
}

export default BillingScreen;
